import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export const DetailField = ({ label, children }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
      {label}
    </Typography>
    <Box sx={{ mt: 0.5 }}>{children}</Box>
  </Box>
);

DetailField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const MultilineText = ({ value }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
    {value
      ? value.split("\n").map((line, i) =>
          line.trim()
            ? <Typography key={i} variant="body2">{line}</Typography>
            : <Box key={i} sx={{ height: "0.5em" }} />
        )
      : <Typography variant="body2" color="text.disabled">—</Typography>
    }
  </Box>
);

MultilineText.propTypes = {
  value: PropTypes.string,
};
